"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _inputRadio = require("@citrus/input-radio");
var _inputTextarea = require("@citrus/input-textarea");
var _inputTextfield = require("@citrus/input-textfield");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _questionBuilder = require("@pcty/question-builder");
var _Radio$Item, _Radio$Item2;
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    question = _ref.question,
    multiLine = _ref.multiLine,
    placeholder = _ref.placeholder,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.textField;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onChangeTextFieldRadio = function onChangeTextFieldRadio(groupId, index, value) {
    var multiLine = value === 'textarea';
    if (onQuestionUpdated) onQuestionUpdated({
      multiLine: multiLine
    });
  };
  var onChangeTextFieldPlaceHolder = function onChangeTextFieldPlaceHolder(id, value) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionPlaceholder: value
    });
  };
  var getTextInputType = function getTextInputType() {
    if (multiLine) {
      return /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
        id: "".concat(id, "-textArea"),
        onChange: function onChange(id, txt) {
          return console.log(txt);
        },
        placeholder: placeholder,
        value: ""
      });
    }
    return /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      className: "pcty-question-builder-option-no-answer",
      id: "".concat(id, "-textField"),
      maxLength: 1000,
      onChange: function onChange(id, txt) {
        return console.log(txt);
      },
      placeholder: placeholder,
      value: ""
    });
  };
  var getTextFieldProperties = function getTextFieldProperties() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-row pcty-margin-top"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-6"
    }, /*#__PURE__*/_react.default.createElement(_inputRadio.Radio, {
      automationId: "".concat(id, "-radio}"),
      id: "".concat(id, "-radio}"),
      label: "Text Input Size",
      onChange: function onChange(groupId, index, value) {
        return onChangeTextFieldRadio(groupId, index, value);
      },
      selectedIndex: multiLine ? 1 : 0,
      style: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    }, _Radio$Item || (_Radio$Item = /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
      automationId: "textfield",
      value: "textfield"
    }, "Single-line")), _Radio$Item2 || (_Radio$Item2 = /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
      automationId: "textarea",
      value: "textarea"
    }, "Multi-line")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-6"
    }, multiLine ? /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
      className: "pcty-question-builder-option-no-answer",
      id: "".concat(id, "-placeholder-textarea"),
      label: "Placeholder Text",
      maxLength: 500,
      onChange: function onChange(id, value) {
        return onChangeTextFieldPlaceHolder(id, value);
      },
      value: placeholder
    }) : /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      className: "pcty-question-builder-option-no-answer",
      id: "".concat(id, "-placeholder-text"),
      label: "Placeholder Text",
      maxLength: 500,
      onChange: function onChange(id, value) {
        return onChangeTextFieldPlaceHolder(id, value);
      },
      value: placeholder
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), !editable && getTextInputType(), editable ? getTextFieldProperties() : null);
};
var _default = exports.default = Presentational;